import React from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";

const SignupSchema = Yup.object().shape({
  password: Yup.string().required("Povinné"),
  newpassword: Yup.string().required("Povinné"),
  renewpassword: Yup.string().required("Povinné").equals([Yup.ref("newpassword")], "Hesla se neshodují"),
});

const Login = () => {
  const navigate = useNavigate();
  const accessToken = useSelector((state) => state.form.accessToken);

  return (
    <>
      <div className="login-card animate-in">
        <h2>Změna hesla</h2>
        <h3></h3>
        <Formik
          initialValues={{
            password: "",
            newpassword: "",
            renewpassword: "",
          }}
          validationSchema={SignupSchema}
          onSubmit={(values) => {
            axios
              .put(
                `${process.env.REACT_APP_BACKEND_URL}/account/changePassword`,
                {
                  id: "apacheee",
                  oldPassword: values.password,
                  newPassword: values.newpassword,
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + accessToken,
                  },
                }
              )
              .then((response) => {
                navigate("/admin/dashboard");
              });
          }}
        >
          {({ errors, touched }) => (
            <Form className="login-form">
              <Field
                name="password"
                type="password"
                placeholder="Staré heslo"
                className="control"
              />
              {errors.password && touched.password ? (
                <div className="error-input">{errors.password}</div>
              ) : null}

              <Field
                name="newpassword"
                type="password"
                placeholder="Nové heslo"
                className="control"
              />
              {errors.newpassword && touched.newpassword ? (
                <div className="error-input">{errors.newpassword}</div>
              ) : null}

              <Field
                name="renewpassword"
                type="password"
                placeholder="Opakuj nové heslo"
                className="control"
              />
              {errors.renewpassword && touched.renewpassword ? (
                <div className="error-input">{errors.renewpassword}</div>
              ) : null}

              <button className="control" type="submit">
                ZMĚNIT HESLO
              </button>
            </Form>
          )}
        </Formik>
        <Link to="/admin/dashboard">
          <button className="send-button">ZPĚT</button>
        </Link>
      </div>
    </>
  );
};

export default Login;
